import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {AccountModel} from "../../models/account.model";

@Component({
  selector: "app-supply-account-link",
  templateUrl: "./supply-account-link.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupplyAccountLinkComponent {
  readonly account = input<AccountModel>();

  readonly params = computed(() => ({id: this.account()?.id}));
}
